import star4 from "../assets/images/icons/4star.png";
import star3 from "../assets/images/icons/3star.png";
import star2 from "../assets/images/icons/2star.png";
import star1 from "../assets/images/icons/1star.png";

const orders = [
  {
    id: "001",
    time: "4:00pm",
    date: "April 18, 2024",
    item: "Watermelon",
    pickupLocation: "Adisa Farms, Plot 20",
    destination: "Number 29, Gbad...",
    status: "Completed",
    rating: 4,
    star: star4,
    quantity: 10,
    region: "Southwest",
    accepted: true,
  },
  {
    id: "002",
    time: "5:00pm",
    date: "April 19, 2024",
    item: "Banana",
    pickupLocation: "Alaba Market",
    destination: "Number 15, Lekki...",
    status: "Pending",
    rating: 3,
    star: star3,
    quantity: 20,
    region: "Southeast",
    accepted: true,
  },
  {
    id: "003",
    time: "3:30pm",
    date: "April 17, 2024",
    item: "Pineapple",
    pickupLocation: "Odogunyan Market",
    destination: "Number 12, Yaba...",
    status: "In Progress",
    rating: 2,
    star: star2,
    quantity: 15,
    region: "Southwest",
    accepted: false,
  },
  {
    id: "004",
    time: "6:00pm",
    date: "April 20, 2024",
    item: "Apples",
    pickupLocation: "Magodo Farms",
    destination: "Number 22, VI...",
    status: "Completed",
    rating: 1,
    star: star1,
    quantity: 30,
    region: "Northwest",
    accepted: true,
  },
  {
    id: "005",
    time: "2:00pm",
    date: "April 15, 2024",
    item: "Coconut",
    pickupLocation: "Iyana Ipaja Market",
    destination: "Number 3, Ikeja...",
    status: "Pending",
    rating: 4,
    star: star4,
    quantity: 25,
    region: "Southwest",
    accepted: false,
  },
  {
    id: "006",
    time: "1:00pm",
    date: "April 21, 2024",
    item: "Oranges",
    pickupLocation: "Epe Farms",
    destination: "Number 8, Festac...",
    status: "Completed",
    rating: 3,
    star: star3,
    quantity: 50,
    region: "Southwest",
    accepted: true,
  },
  {
    id: "007",
    time: "4:15pm",
    date: "April 22, 2024",
    item: "Mangoes",
    pickupLocation: "Oyingbo Market",
    destination: "Number 19, Surulere...",
    status: "Pending",
    rating: 2,
    star: star2,
    quantity: 40,
    region: "Southwest",
    accepted: false,
  },
  {
    id: "008",
    time: "12:30pm",
    date: "April 23, 2024",
    item: "Grapes",
    pickupLocation: "Ketu Farms",
    destination: "Number 7, Ikorodu...",
    status: "In Progress",
    rating: 4,
    star: star4,
    quantity: 35,
    region: "Southwest",
    accepted: true,
  },
  {
    id: "009",
    time: "3:00pm",
    date: "April 24, 2024",
    item: "Strawberries",
    pickupLocation: "Lekki Greenhouse",
    destination: "Number 5, VI...",
    status: "Completed",
    rating: 1,
    star: star1,
    quantity: 45,
    region: "Southwest",
    accepted: false,
  },
  {
    id: "010",
    time: "11:00am",
    date: "April 25, 2024",
    item: "Carrots",
    pickupLocation: "Mile 12 Market",
    destination: "Number 10, Ajah...",
    status: "Pending",
    rating: 3,
    star: star3,
    quantity: 20,
    region: "Southwest",
    accepted: true,
  },
  {
    id: "011",
    time: "10:30am",
    date: "April 26, 2024",
    item: "Peppers",
    pickupLocation: "Badagry Farms",
    destination: "Number 4, Sango...",
    status: "Completed",
    rating: 2,
    star: star2,
    quantity: 60,
    region: "Southwest",
    accepted: false,
  },
  {
    id: "012",
    time: "8:30am",
    date: "April 27, 2024",
    item: "Avocado",
    pickupLocation: "Epe Farms",
    destination: "Number 6, Alimosho...",
    status: "In Progress",
    rating: 4,
    star: star4,
    quantity: 70,
    region: "Southwest",
    accepted: true,
  },
  {
    id: "013",
    time: "9:15am",
    date: "April 28, 2024",
    item: "Tomatoes",
    pickupLocation: "Idumota Market",
    destination: "Number 2, Marina...",
    status: "Pending",
    rating: 3,
    star: star3,
    quantity: 85,
    region: "Southwest",
    accepted: false,
  },
  {
    id: "014",
    time: "7:45am",
    date: "April 29, 2024",
    item: "Lettuce",
    pickupLocation: "Ikoyi Farms",
    destination: "Number 18, Ikoyi...",
    status: "Completed",
    rating: 2,
    star: star2,
    quantity: 55,
    region: "Southwest",
    accepted: true,
  },
  {
    id: "015",
    time: "6:00pm",
    date: "April 30, 2024",
    item: "Spinach",
    pickupLocation: "Oshodi Market",
    destination: "Number 25, Maryland...",
    status: "In Progress",
    rating: 4,
    star: star4,
    quantity: 25,
    region: "Southwest",
    accepted: false,
  },
  {
    id: "016",
    time: "2:00pm",
    date: "May 1, 2024",
    item: "Potatoes",
    pickupLocation: "Ogba Farms",
    destination: "Number 8, Agege...",
    status: "Pending",
    rating: 3,
    star: star3,
    quantity: 90,
    region: "Southwest",
    accepted: true,
  },
  {
    id: "017",
    time: "5:15pm",
    date: "May 2, 2024",
    item: "Onions",
    pickupLocation: "Garki Farms",
    destination: "Number 16, Abuja...",
    status: "Completed",
    rating: 1,
    star: star1,
    quantity: 75,
    region: "Northcentral",
    accepted: false,
  },
  {
    id: "018",
    time: "1:00pm",
    date: "May 3, 2024",
    item: "Beets",
    pickupLocation: "Enugu Farms",
    destination: "Number 9, Enugu...",
    status: "In Progress",
    rating: 4,
    star: star4,
    quantity: 65,
    region: "Southeast",
    accepted: true,
  },
  {
    id: "019",
    time: "3:45pm",
    date: "May 4, 2024",
    item: "Garlic",
    pickupLocation: "Kaduna Farms",
    destination: "Number 14, Kaduna...",
    status: "Pending",
    rating: 2,
    star: star2,
    quantity: 80,
    region: "Northwest",
    accepted: false,
  },
  {
    id: "020",
    time: "10:00am",
    date: "May 5, 2024",
    item: "Cherries",
    pickupLocation: "Calabar Farms",
    destination: "Number 20, Calabar...",
    status: "Completed",
    rating: 3,
    star: star3,
    quantity: 100,
    region: "Southsouth",
    accepted: true,
  },
];

export default orders;